export default __webpack_public_path__ + "static/media/Metropolis-BoldItalic.1eb34a2f.otf";